import { render, staticRenderFns } from "./newIssuePrint.vue?vue&type=template&id=0677a5f4&scoped=true"
import script from "./newIssuePrint.vue?vue&type=script&lang=js"
export * from "./newIssuePrint.vue?vue&type=script&lang=js"
import style0 from "./newIssuePrint.vue?vue&type=style&index=0&id=0677a5f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0677a5f4",
  null
  
)

export default component.exports